import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import { Button, Checkbox, IconButton } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { createMRTColumnHelper } from "material-react-table";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MDAlert from "../../components/MDAlert";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import { AuthContext } from "../../context";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";
import showToast from "../../utils/toast";
import GenericTable from "../genericTable";
// GraphQL import removed - now using REST endpoint

export default function JournalActivityAdd() {
	const authContext = useContext(AuthContext);
	const { id, date } = useParams();
	const [weatherOptions, setWeatherOptions] = useState([]);
	const [jobsOptions, setJobsOptions] = useState([]);
	const [activity, setActivity] = useState([]);
	const [originalActivity, setOriginalActivity] = useState([]);
	const [appealInfo, setAppealInfo] = useState({});
	const [hoursToInsert, setHoursToInsert] = useState(0);
	const url_api = "/activity-management/";
	const columnHelper = createMRTColumnHelper();
	const [errorFields, setErrorFields] = useState([]);
	const navigate = useNavigate();

	const handleSetNotification = (msg, severityType) => {
		showToast(msg, severityType);
	};

	useEffect(() => {
		if (id && date) {
			//console.log("id", id)
			//console.log("date", date)
			apiService
				.get(
					url_api,
					{
						id_area: localStorage.getItem("areaSelected"),
						date: date,
						id_user: id,
					},
					{}
				)
				.then((data) => {
					setActivity(data);
					setOriginalActivity(data);
					//console.log(data)
				})
				.catch((error) =>
					handleSetNotification(
						"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #1018349",
						"error"
					)
				);

			apiService
				.get(
					"/appeal-management/",
					{
						id: localStorage.getItem("areaSelected"),
						date: date,
						user_id: id,
					},
					{}
				)
				.then((data) => {
					setAppealInfo(data);
					//console.log(data)
				})
				.catch((error) =>
					handleSetNotification(
						"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #1018835349",
						"error"
					)
				);
		}
	}, [id, date]);

	useEffect(() => {
		apiService
			.get("/weather-types/")
			.then((data) => {
				if (data && Array.isArray(data)) setWeatherOptions(data);
			})
			.catch((error) => {
				console.log(error);
				handleSetNotification(
					"Qualcosa è andato storto durante il caricamento delle tipologia di clima. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #8734539",
					"error"
				);
			});
		apiService
			.get(
				"/jobs-management/",
				{
					area_id: localStorage.getItem("areaSelected"),
					options: true,
				},
				{}
			)
			.then((data) => {
				setJobsOptions(data);
			})
			.catch((error) =>
				handleSetNotification(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #1018349",
					"error"
				)
			);
	}, []);

	const columns = [
		columnHelper.accessor("delete", {
			header: " ",
			size: 20,
			Cell: ({ row }) => {
				return (
					<IconButton
						size="large"
						color="error"
						onClick={() => {
							setActivity((prevData) => prevData.filter((item) => item.id_activity !== row.original.id_activity));
						}}
					>
						<DeleteIcon />
					</IconButton>
				);
			},
		}),
		columnHelper.accessor("activity", {
			header: "Attività",
			size: 250,
			Cell: ({ row }) => {
				return (
					<Autocomplete
						options={jobsOptions}
						getOptionLabel={(option) => option.name}
						value={row?.original?.activity}
						renderInput={(params) => (
							<TextField {...params} error={errorFields.includes(row.original.id_activity + "_activity")} label="Attività" />
						)}
						isOptionEqualToValue={(option, value) => {
							return value === option.id;
						}}
						onChange={(event, newValue) => {
							setActivity((prevData) =>
								prevData.map((item) =>
									item.id_activity === row.original.id_activity
										? {
												...item,
												activity: newValue || null,
											}
										: item
								)
							);
						}}
					/>
				);
			},
		}),
		columnHelper.accessor("hours", {
			header: "Ore",
			size: 70,
			Cell: ({ row }) => {
				return (
					<TextField
						id="outlined-number"
						label="Hours"
						type="number"
						error={errorFields.includes(row.original.id_activity + "_hours")}
						InputLabelProps={{
							shrink: true,
						}}
						variant="outlined"
						value={row.original.hours}
						onChange={(event) => {
							setActivity((prevData) =>
								prevData.map((item) =>
									item.id_activity === row.original.id_activity
										? {
												...item,
												hours: event.target.value || null,
											}
										: item
								)
							);
						}}
					/>
				);
			},
		}),
		columnHelper.accessor("extra", {
			header: "Extra",
			size: 20,
			Cell: ({ row }) => {
				return (
					<Checkbox
						checked={row.original.extra}
						sx={{
							transform: "scale(1.8)", // Ingrandisce la Checkbox di 1.5 volte
							"& .MuiSvgIcon-root": { fontSize: 30 }, // Ingrandisce l'icona all'interno della Checkbox
						}}
						onChange={(event) => {
							setActivity((prevData) =>
								prevData.map((item) =>
									item.id_activity === row.original.id_activity
										? {
												...item,
												extra: event.target.checked,
											}
										: item
								)
							);
						}}
					/>
				);
			},
		}),
		columnHelper.accessor("view_on_GDL", {
			header: "GDL",
			size: 20,
			Cell: ({ row }) => (
				<Checkbox
					checked={row.original.view_on_GDL}
					sx={{
						transform: "scale(1.8)", // Ingrandisce la Checkbox di 1.5 volte
						"& .MuiSvgIcon-root": { fontSize: 30 }, // Ingrandisce l'icona all'interno della Checkbox
					}}
					onChange={(event) => {
						setActivity((prevData) =>
							prevData.map((item) =>
								item.id_activity === row.original.id_activity
									? {
											...item,
											view_on_GDL: event.target.checked,
										}
									: item
							)
						);
					}}
				/>
			),
		}),
	];

	useEffect(() => {
		// Calcola la somma delle ore inserite nell'attività
		const totalInsertedHours = activity.reduce((total, item) => {
			return total + (parseFloat(item.hours) || 0); // Somma le ore, considerando 0 se non ci sono valori
		}, 0);

		// Calcola le ore rimanenti da inserire, assicurandoti che appealInfo.hours_of_work sia definito
		const remainingHours = (appealInfo?.hours_of_work || 0) - totalInsertedHours;

		// Aggiorna il valore di hoursToInsert
		setHoursToInsert(remainingHours);
	}, [activity, appealInfo?.hours_of_work]); // Esegui il calcolo quando activity o hours_of_work cambiano

	function addActivity() {
		const newActivity = {
			id_activity: new Date().getTime(),
			activity: null,
			hours: null,
			extra: false,
			view_on_GDL: false,
		};
		setActivity([...activity, newActivity]);
	}

	function validateFields() {
		let errorFieldstemp = [];
		activity.forEach((item) => {
			if (!item.activity) {
				errorFieldstemp.push(item.id_activity + "_activity");
			}
			if (!item.hours || item.hours <= 0) {
				errorFieldstemp.push(item.id_activity + "_hours");
			}
		});

		if (errorFieldstemp.length > 0) {
			setErrorFields(errorFieldstemp);
			return false;
		}

		return true;
	}

	function saveActivity() {
		if (!validateFields()) {
			handleSetNotification("Attenzione! Seleziona attività e ore per ogni attività", "warning");
			return null;
		}
		setErrorFields([]);
		apiService
			.post(
				url_api,
				{},
				{
					id_area: localStorage.getItem("areaSelected"),
					date: date,
					id_user: id,
					activity: activity,
				}
			)
			.then((data) => {
				debugger;
				handleSetNotification("Attività salvate con successo!", "success");
			})
			.catch((error) =>
				handleSetNotification(
					"Errore durante il salvataggio. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #98463149",
					"error"
				)
			);
	}

	return authContext.hasAuth("ADD_DAILYACTIVITY") || authContext.hasAuth("EDIT_DAILYACTIVITY") ? (
		<>
			<DashboardLayout>
				<DashboardNavbar />
				<Button
					variant="contained"
					color={"primary"}
					sx={{
						color: "white!important",
						marginTop: "20px",
						marginLeft: "20px",
						marginBottom: "20px",
					}}
					onClick={() => navigate(-2)}
				>
					Torna alle presenze
				</Button>
				<center>
					<MDBox
						sx={{
							display: "flex",
							justifyContent: "center",
							flexDirection: "column",
							alignItems: "center",
							backgroundColor: "#f8f5f5",
							width: "fit-content",
							padding: "20px",
							borderRadius: "10px",
							marginBottom: "20px",
							boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
						}}
					>
						<Typography variant="h5" color={"black"}>
							{appealInfo?.supplier_name}:
						</Typography>
						<Typography variant="h5" color={"black"}>
							{appealInfo?.name}
						</Typography>
						<br />
						{hoursToInsert > 0 && hoursToInsert !== 1 && (
							<Typography variant="h5">Devi inserire ancora {hoursToInsert} ore</Typography>
						)}
						{hoursToInsert === 1 && <Typography variant="h5">Devi inserire ancora {hoursToInsert} ora</Typography>}
						{hoursToInsert === 0 && <Typography variant="h5">Hai inserito tutte le ore</Typography>}
						{hoursToInsert < 0 && (
							<Typography variant="h5" color={"error"}>
								Hai inserito più ore rispetto a quelle specificate nell'appello.
							</Typography>
						)}
					</MDBox>
					{hoursToInsert > 0 && (
						<IconButton
							size="large"
							sx={{
								background: "linear-gradient(195deg, #42424a, #191919)",
								color: "white!important",
								marginBottom: "20px",
							}}
							onClick={() => addActivity()}
						>
							<AddCircleIcon sx={{ transform: "scale(2)" }} />
						</IconButton>
					)}
					{hoursToInsert === 0 && JSON.stringify(activity) !== JSON.stringify(originalActivity) && (
						<Button
							size="large"
							sx={{
								background: "linear-gradient(195deg, #42424a, #191919)",
								color: "white!important",
								marginBottom: "20px",
							}}
							onClick={() => saveActivity()}
							startIcon={<SaveIcon />}
						>
							Salva
						</Button>
					)}
				</center>
				<MDBox style={{ width: "100%", marginTop: "20px" }}>
					<GenericTable authModelName={"DAILYACTIVITY"} disableButton={true} columns={columns} data={activity} />
				</MDBox>
			</DashboardLayout>
		</>
	) : (
		<DashboardLayout>
			<MDAlert color="error" dismissible>
				<MDTypography variant="body2">You don't have permission to access this page</MDTypography>
			</MDAlert>
		</DashboardLayout>
	);
}
